import(/* webpackMode: "eager", webpackExports: ["IS_SAFARI","IS_IOS","IS_APPLE_WEBKIT"] */ "/root/viholo-web/node_modules/@payloadcms/richtext-lexical/dist/lexical/utils/environment.js");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/root/viholo-web/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/src/blocks/FAQ/index.module.scss");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/src/blocks/Content/content.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/blocks/ProductList/components/ProductListFilter.tsx");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/src/components/ArticleCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/components/Carousel/carouselClient.tsx");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/src/components/ListSort/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/root/viholo-web/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/root/viholo-web/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/src/components/Pagination/index.tsx");
